import { useContext } from 'react';
import { Location, UNSAFE_LocationContext } from 'react-router-dom';

/**
 * La ubicación del router, o `null` si el componente se pinta FUERA de él.
 *
 * Los modales viven fuera del árbol del router (`App.tsx`: `<Router />` y
 * `<SuperModal />` son hermanos), y `useLocation()` lanza ahí. Un componente
 * que se usa en las dos partes —el bloque «Operarios y vehículos» del
 * asistente, que «Mover tramos» (plan 2026-10-15 § 3) reutiliza en su modal—
 * lee la ubicación con esto: dentro del router devuelve lo mismo que
 * `useLocation()`; fuera, `null`.
 */
export function useOptionalLocation(): Location | null {
  return useContext(UNSAFE_LocationContext)?.location ?? null;
}
